import { render } from "./EmailPreviewPanel.vue?vue&type=template&id=ffa81b68&scoped=true"
import script from "./EmailPreviewPanel.vue?vue&type=script&lang=js"
export * from "./EmailPreviewPanel.vue?vue&type=script&lang=js"

import "./EmailPreviewPanel.vue?vue&type=style&index=0&id=ffa81b68&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa81b68"]])

export default __exports__